import { selectStpRates } from '@va/aaas/shared/selectors';
import { moduleNames, tabNames } from '@va/constants';
import { isModuleEnabled as isModuleEnabledSelector } from '@va/dashboard/selectors/app';
import { ChatBotIcon } from '@va/icons';
import { useTranslate } from '@va/localization';
import { getNavIconByName } from '@va/standalone/shared/helpers';
import { getUserRole } from '@va/standalone/shared/selectors';
import { isEcomModuleEnabled } from '@va/util/helpers';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useCurrentWebsiteStpData = () => {
  const translate = useTranslate();
  const userRole = useSelector(getUserRole);
  const isModuleEnabled = useSelector(isModuleEnabledSelector);

  const {
    stpConsumedVisit,
    stpConsumedVisitEvent,
    stpConsumedSessionRecording,
    stpConsumedHeatmapIncrement,
    stpConsumedEcomEvent,
    stpConsumedAiQuery,
  } = useSelector(selectStpRates);

  const rowLabelBaseKey = 'pageHeader.stpCounter.tp';

  const currentWebsiteStpData = useMemo(
    () => [
      {
        stpConsumedLabel: translate(`${rowLabelBaseKey}.visits`),
        stpConsumed: stpConsumedVisit,
        icon: getNavIconByName(tabNames.pageVisits, false, '#ffffffd4'),
      },
      {
        stpConsumedLabel: translate(`${rowLabelBaseKey}.recordings`),
        stpConsumed: stpConsumedSessionRecording,
        icon: getNavIconByName(tabNames.recordings, false, '#ffffffd4'),
        hidden: !isModuleEnabled(moduleNames.sessionRecordings),
      },
      {
        stpConsumedLabel: translate(`${rowLabelBaseKey}.heatmaps`),
        stpConsumed: stpConsumedHeatmapIncrement,
        icon: getNavIconByName(tabNames.heatmaps, false, '#ffffffd4'),
        hidden: !isModuleEnabled(moduleNames.heatmaps),
      },
      // TODO: add back once the credit consumption is implemented for these modules
      // {
      //   stpConsumedLabel: translate(`${rowLabelBaseKey}.funnels`),
      //   stpConsumed: stpConsumedFunnelMatch,
      //   icon: getNavIconByName(tabNames.funnels, false, '#ffffffd4'),
      //   hidden: !isModuleEnabled(moduleNames.funnels),
      // },
      // {
      //   stpConsumedLabel: translate(`${rowLabelBaseKey}.polls`),
      //   stpConsumed: stpConsumedPollAnswer,
      //   icon: getNavIconByName(tabNames.polls, false, '#ffffffd4'),
      //   hidden: !isModuleEnabled(moduleNames.polls),
      // },
      // {
      //   stpConsumedLabel: translate(`${rowLabelBaseKey}.surveys`),
      //   stpConsumed: stpConsumedSurveyAnswer,
      //   icon: getNavIconByName(tabNames.surveys, false, '#ffffffd4'),
      //   hidden: !isModuleEnabled(moduleNames.surveys),
      // },
      {
        stpConsumedLabel: translate(`${rowLabelBaseKey}.events`),
        stpConsumed: stpConsumedVisitEvent,
        icon: getNavIconByName(tabNames.eventTracking, false, '#ffffffd4'),
        hidden: !isModuleEnabled(moduleNames.eventTracking),
      },
      {
        stpConsumedLabel: translate(`${rowLabelBaseKey}.ecom`),
        stpConsumedLabelTooltip: translate(`${rowLabelBaseKey}.rate.ecomTooltip`),
        stpConsumed: stpConsumedEcomEvent,
        icon: getNavIconByName(tabNames.ecommerce, false, '#ffffffd4'),
        hidden: !isEcomModuleEnabled(userRole),
      },
      {
        stpConsumedLabel: translate(`${rowLabelBaseKey}.aiChatbot`),
        stpConsumedLabelTooltip: translate(`${rowLabelBaseKey}.aiChatbotTooltip`),
        stpConsumed: stpConsumedAiQuery,
        icon: <ChatBotIcon />,
      },
    ],
    [
      isModuleEnabled,
      stpConsumedAiQuery,
      stpConsumedEcomEvent,
      stpConsumedHeatmapIncrement,
      stpConsumedSessionRecording,
      stpConsumedVisit,
      stpConsumedVisitEvent,
      translate,
      userRole,
    ],
  );

  return currentWebsiteStpData;
};
